(function () {
  'use strict';

  /*
   * ============================================================
   * RAZORPAY RETURN / PRODUCT PAGE RECOVERY
   * ============================================================
   *
   * Purpose:
   *
   * When the customer returns from Razorpay checkout,
   * the browser may restore the product page from its previous
   * state. Some theme JavaScript components can then remain
   * in an incorrect state.
   *
   * This script detects a browser restoration and performs
   * a controlled page refresh.
   *
   * IMPORTANT:
   * We only do this when the page was restored from browser
   * history/cache. Normal product-page loads are NOT refreshed.
   * ============================================================
   */


  var recoveryStarted = false;


  function recoverProductPage() {

    /*
     * Prevent the recovery from running more than once.
     */

    if (recoveryStarted) {
      return;
    }

    recoveryStarted = true;


    /*
     * Give Razorpay/theme a tiny amount of time to finish
     * removing its checkout overlay before refreshing.
     */

    setTimeout(function () {

      /*
       * Force a fresh product-page load.
       *
       * This gives all Shopify/theme JavaScript components
       * a completely clean initialization.
       */

      window.location.reload();

    }, 100);

  }


  /*
   * ============================================================
   * PAGESHOW
   * ============================================================
   *
   * event.persisted === true means the browser restored the
   * page from its back-forward cache (bfcache).
   *
   * This is exactly the situation where a page can visually
   * return but retain stale JavaScript/component state.
   * ============================================================
   */

  window.addEventListener('pageshow', function (event) {

    if (event.persisted) {

      recoverProductPage();

    }

  });


  /*
   * ============================================================
   * PERFORMANCE NAVIGATION CHECK
   * ============================================================
   *
   * Some browsers don't reliably expose the condition through
   * event.persisted alone.
   *
   * Therefore we also inspect the navigation entry.
   * ============================================================
   */

  try {

    var navigationEntries =
      performance.getEntriesByType('navigation');

    if (
      navigationEntries &&
      navigationEntries.length
    ) {

      var navigation =
        navigationEntries[0];


      if (
        navigation.type === 'back_forward'
      ) {

        /*
         * Wait until the current page has finished loading.
         */

        if (document.readyState === 'complete') {

          recoverProductPage();

        } else {

          window.addEventListener(
            'load',
            function () {
              recoverProductPage();
            },
            {
              once: true
            }
          );

        }

      }

    }

  } catch (error) {

    /*
     * Do nothing if the browser doesn't support
     * performance navigation entries.
     */

    console.warn(
      'Razorpay return recovery check failed:',
      error
    );

  }


})();